import { useState } from "react";
import { pluralize, listFormatter } from '../utils.mjs';
import TokenIcon from "./TokenIcon.mjs";
import Loading from "./Loading.mjs";

export default function RedemptionModal({ userAccount, preferredLocation, totalCost, perks, perkNames }) {
  const [isLoading, setIsLoading] = useState(false);
  const cardClasses = "p-3 bg-light shadow";
  const makeCardStack = (qty) => {
    // Max fake card quantity of 3, otherwise it cuts into the other cards and text.
    const quantity = qty < 2 ? qty : 2;
    const spacer = 0.5;
    let bgCards = [];
    for (let i = 1; i <= quantity; i++) {
      const offset = {
        top: `${spacer * i}rem`,
        left: `${spacer * i}rem`,
      };
      bgCards.push(
        <div
          className={`fake-card position-absolute w-100 h-100 ${cardClasses}`}
          key={i}
          style={offset}
        ></div>,
      );
    }
    return bgCards.reverse();
  };

  const [confirmed, setConfirmed] = useState(false);
  const handleConfirm = (e) => {
    setConfirmed(e.target.checked);
  }

  async function handleRedeem() {
    setIsLoading(true);

    const mappedPerksToRedeem = perks => {
      return perks.map(p => {
        return {
          primePerkId: p.id,
          count: p.qty,
        }
      });
    };

    const thisModal = document.querySelector('#redemption-modal');
    const thisModalInstance = bootstrap.Modal.getInstance(thisModal);
    thisModalInstance._config.backdrop = 'static';
    thisModal.classList.remove('fade');

    const successModal = new bootstrap.Modal('#redemption-success-modal');
    const errorModal = new bootstrap.Modal('#redemption-error-modal');

    Promise.resolve(userAccount.redeemPrimeTokens(mappedPerksToRedeem(perks), preferredLocation))
      .then((response) => {
        thisModalInstance.hide();
        setIsLoading(false);

        // A success response simply returns a `true`.
        successModal.toggle();
        thisModal.classList.add('fade');
      })
      .catch((error) => {
        thisModalInstance.hide();
        setIsLoading(false);

        errorModal.toggle();
        thisModal.classList.add('fade');

        console.log('Something went wrong trying to redeem these perks: ')
        console.error(error);
      })
    ;
  }

  return (
    <div
      className="modal fade"
      tabIndex="-1"
      aria-hidden="true"
      aria-label="Redeem Prime Tokens"
      id="redemption-modal"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {isLoading ? false :
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          }

          <div className="modal-body p-4">

            { isLoading ? <Loading /> :
              <div className="vstack gap-4">
                <p className="subhead-1 text-primary mb-1">
                  Prime Token Redemption
                </p>
                <div className="row justify-content-center g-2">
                  {perks.map((perk, i) => {
                    const {
                      icon,
                      fullName,
                      description,
                      qty
                    } = perk;
                    return (
                      <div className="col-6" key={i}>
                        <div className="p-2">
                          <div className="card-stack position-relative">
                            <div
                              className={` ${cardClasses} vstack gap-2 justify-content-center align-items-center position-relative z-1 text-center`}
                            >
                              <TokenIcon name={icon} className="text-primary" />
                              <span className="h4 mb-1 text-body">{fullName}</span>
                              <span className="label-3 d-block">
                              {description}
                            </span>
                            </div>
                            {qty > 1 && makeCardStack(perk.qty - 1)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div>
                  <p className="mb-0">
                    You are redeeming {pluralize(totalCost.tokens, "Prime Token")}
                    {totalCost.score > 0 &&
                      ` and ${totalCost.score.toLocaleString()} WScore`}{" "}
                    for {listFormatter.format(perkNames)}. This selection is final
                    and cannot be changed after confirming.
                  </p>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    required
                    id="redeem-confirm"
                    name="redeem-confirm"
                    checked={confirmed}
                    onChange={handleConfirm}
                    onSubmit={() => false} // this is to prevent submitting from adding it to the url as a parameter
                  />
                  <label className="form-check-label" htmlFor="redeem-confirm">
                    I confirm that I would like to redeem{" "}
                    {pluralize(totalCost.tokens, "Prime Token")}{" "}
                    {totalCost.score > 0 &&
                      ` and ${totalCost.score.toLocaleString()} WScore`}{" "}
                    for the selected Prime Perks.
                  </label>
                </div>
              </div>
            }

          </div>

          {isLoading ? false :
            <div className="modal-footer justify-content-between px-md-4">
              <button
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Back
              </button>

              <button className="btn btn-primary pe-auto" type="submit" disabled={!confirmed} onClick={handleRedeem} id="redemption-submit">
                Redeem
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
